import styled from 'styled-components';
import { Form } from 'antd';

import { ButtonWithLoader } from '../../components/ui-helpers/';

export const RequestInfoWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const ContactName = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.fontLightBlack};
`;

export const RequestSource = styled.div`
  margin: 0 15px;
  padding: 3px 12px;
  border-radius: 50px;
  background-color: ${({ color }) => color};
  color: ${props => props.theme.colors.white};
`;

export const RequestStatus = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ color }) => color};
`;

export const MeetingNoteInfoWrap = styled.div`
  margin-top: 18px;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  resize: none;
  padding: 15px;
  min-height: 264px;
  border: 1px solid ${({ theme }) => theme.colors.borderLightestSilver};
`;

export const MeetingInfoDateTimeWrap = styled.div`
  display: flex;
`;

export const MeetingInfoDateTimeItem = styled.div`
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-right: 30px;
  }

  & > span {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.fontSilverLighter};
  }
`;

export const ButtonWrap = styled.div`
  margin-top: 20px;
  text-align: center;

  ${ButtonWithLoader} {
    height: 40px;
    max-width: 160px;
    border-radius: 30px;
  }
`;

export const FormItem = styled(Form.Item)`
  .ant-form-item-control {
    line-height: 34px;
  }
`;

export const QuillTextWrap = styled.div`
  margin-top: 5px;
  margin-bottom: 3px;

  label {
    line-height: 2;
  }
`;



// WEBPACK FOOTER //
// ./src/modals/meeting-notes-modal/styles.js